import { Component, h } from '@stencil/core';

@Component({
  tag: 'app-frame',
  styleUrl: 'app-frame.css',
  shadow: true,
})
export class AppFrame {

  render() {
    return (
<ix-application>
  <ix-application-header>
    <div class="placeholder-logo" slot="logo">
      <img alt="siemens-logo" src="/assets/logo.svg" class="app-logo" />
    </div>
  </ix-application-header>
  <ix-menu>
    <ix-menu-item>Setting</ix-menu-item>
  </ix-menu>
  <ix-content>
    <div class="content-header">
      <slot name="header"></slot>
      </div>
    <slot name="content-table"></slot>
    <slot name="content-form"></slot>
  </ix-content>
</ix-application>
    ) 
  }
}
